import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgFile(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "file_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#file_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M53.14 15.122l1.053-1.068-1.053 1.068zM42.705 4.832l1.054-1.068-1.054 1.068zm-2.027.668H12.414v-3h28.264v3zM11.5 6.414v51.172h-3V6.414h3zm.914 52.086h39.172v3H12.414v-3zm40.086-.914V17.178h3v40.408h-3zm-.413-41.396L41.652 5.9l2.107-2.136 10.434 10.29-2.106 2.136zm.413.988c0-.371-.149-.727-.413-.988l2.106-2.136a4.388 4.388 0 011.307 3.124h-3zM51.586 58.5c.505 0 .914-.41.914-.914h3a3.914 3.914 0 01-3.914 3.914v-3zM11.5 57.586c0 .505.41.914.914.914v3A3.914 3.914 0 018.5 57.586h3zM12.414 5.5a.914.914 0 00-.914.914h-3A3.914 3.914 0 0112.414 2.5v3zm28.264-3c1.153 0 2.26.454 3.08 1.264L41.653 5.9c-.26-.256-.61-.4-.974-.4v-3z",
        fill: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M52.206 16.04h-8.761a2.414 2.414 0 01-2.414-2.414V4.89",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M18 45h4",
        stroke: "#FF6652",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M18 35h4",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M18 26h4",
        stroke: "#FF6652",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M27 45h19",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M27 35h19",
        stroke: "#FF6652",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M27 26h19",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgFile;